import type { Metadata } from "next";
import { PrivacyView } from "@/components/legal/privacy-view";

export const metadata: Metadata = {
  title: "Privacy Policy",
  description:
    "Privacy Policy for Quto AI. What we collect, how we use it, DPDP- and GDPR-aware handling, and your data rights.",
  alternates: { canonical: "/privacy" },
};

export default function PrivacyPage() {
  return <PrivacyView />;
}
